import { Category } from "../../types/category.interface";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { LuArrowRightCircle } from "react-icons/lu";

export interface ICardProp {
  item: {
    id: number;
    slug: string;
    title: string;
    content: string;
    imageAlt: string;
    image: string;
    createdAt: Date;
    publish: boolean;
    categories: Category[];
  };
}

const Card: React.FC<ICardProp> = ({ item }) => {
  const createdDate = new Date(item.createdAt);

  return (
    <Link  href={`/${item.slug}`}>
      <a>
        <div
          className="relative flex flex-col cursor-pointer rounded-md w-full bg-white border h-full border-gray-200 md:min-w-[310px]"
        >
          <div className="w-full relative rounded-t-md aspect-video overflow-hidden">
            <Image
              layout="fill"
              src={`https://api.bungalowfinder.ca` + item.image}
              alt={item.imageAlt}
            />
          </div>

          <article className="px-3 flex flex-col py-2 gap-4">
              <h2 className="text-sm md:text-base leading-7 capitalize font-medium line-clamp-1">
                {item.title}
              </h2>
            <div className="flex justify-between text-sm items-baseline">
              <span className="uppercase">
                {Intl.DateTimeFormat("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }).format(createdDate)}{" "}
              </span>
              <span className="flex justify-center items-center gap-2">
                Read More <LuArrowRightCircle fontSize={18} />
              </span>
            </div>
          </article>
        </div>
      </a>
    </Link>
  );
};

export default Card;
